import { render, staticRenderFns } from "./popBoxcontent.vue?vue&type=template&id=136c9de6&"
import script from "./popBoxcontent.vue?vue&type=script&lang=js&"
export * from "./popBoxcontent.vue?vue&type=script&lang=js&"
import style0 from "./popBoxcontent.vue?vue&type=style&index=0&id=136c9de6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports